<script>
    import app from "../stores/app";
    import user from "../stores/user";
    import localTransfers from "../stores/localTransfers";
    import {LOCAL_STATUS, LOCAL_STATUSES, LOCAL_TYPES} from "../lib/constants";
    import {formatDate} from "../lib/lib";
    import {createEventDispatcher} from 'svelte/internal';
    import TableHeader from "../components/TableHeader.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";

    const tableColumns = [
        {key: 'date', title: 'DATE'},
        {key: 'type_id', title: 'BOOK TYPE'},
        {key: 'time', title: 'TIME'},
        {key: 'pickup_name', title: 'PICKUP'},
        {key: 'room_no', title: 'ROOM'},
        {key: 'drop_name', title: 'DESTINATION'},
        {key: 'passengers', title: 'PAX'},
        {key: 'price', title: 'PRICE'},
        {key: 'arrival_time', title: 'ARR. TIME'},
        {key: 'taxi', title: 'TAXI'},
        {key: 'status_id', title: 'STATUS'},
        {key: '', title: '', hidden: !user.canDeleteTransfers()},
    ];

    const dispatch = createEventDispatcher();

    const onEdit = (local_id) => {
        if (user.canEditTransfers()) {
            dispatch("edit", local_id);
        } else {
            dispatch("view", local_id);
        }
    }

    const onDelete = (transfer) => {
        dispatch("delete", transfer);
    }
</script>

<table class="table table-list table-list-border table-sm table-locals mb-4">
    <TableHeader {tableColumns} on:sort/>
    <tbody>
    {#each $localTransfers.list as transfer}
        <tr class="row-hover pointer"
            class:row-selected="{ $localTransfers.selectedId === transfer.id }"
            on:click="{ () => onEdit(transfer.id) }">
            <td class="date-column">
                <div class="status-type status-{ transfer.status_id }"></div>
                { transfer.date }
            </td>
            <td class="text-gray">
                { LOCAL_TYPES[transfer.type_id] }
            </td>
            <td class="time-column text-gray">
                { transfer.time }
            </td>
            <td class="text-gray">
                { transfer.pickup_name }
                {#if transfer.pickup_address}
                    <div>{ transfer.pickup_address }</div>
                {/if}
            </td>
            <td class="text-gray">
                { transfer.room_no }
            </td>
            <td class="text-gray">
                { transfer.drop_name }
                {#if transfer.drop_address}
                    <div>{ transfer.drop_address }</div>
                {/if}
            </td>
            <td class="text-gray text-center pax-column">
                { transfer.passengers }
            </td>
            <td class="text-gray text-end price-column">
                { transfer.price }
            </td>
            <td class="text-gray text-end price-column">
                { transfer.arrival_time }
            </td>
            <td class="text-gray">
                {#if transfer.transporter}
                    { transfer.transporter.name }
                {:else}
                    {#if transfer.taxi}
                        { transfer.taxi.taxi_number }/{ transfer.taxi.licence_no }
                    {/if}
                    {#if transfer.driver}
                        <div class="text-gray">{ transfer.driver.name }</div>
                    {/if}
                {/if}
            </td>
            <td class="status-column status-{transfer.status_id }">
                { LOCAL_STATUSES[transfer.status_id] }
            </td>
            {#if user.canDeleteTransfers()}
                <td class="button-column pointer" title="delete local transfer"
                    on:click|preventDefault|stopPropagation="{ () => onDelete(transfer) }">
                    <AppIcon icon="trash" size="16"/>
                </td>
            {/if}
        </tr>
    {/each}
    </tbody>
</table>

<style>
    .table-locals .date-column {

    }

    .table-locals .price-column {
        width: 70px;
    }

    .table-locals .pax-column {
        width: 40px;
    }

    .table-locals .status-type {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        width: 5px;
    }

    /* ASSIGNED */
    .table-locals .status-type.status-2 {
        background: var(--local-status-assigned-color);
    }

    .table-locals .status-column.status-2 {
        color: var(--local-status-assigned-color);
    }

    /* ACCEPTED */
    .table-locals .status-type.status-3 {
        background: var(--local-status-accepted-color);
    }

    .table-locals .status-column.status-3 {
        color: var(--local-status-accepted-color);
    }

    /* REJECTED */
    .table-locals .status-type.status-1 {
        background: var(--local-status-rejected-color);
    }

    .table-locals .status-column.status-1 {
        font-weight: 500;
        color: var(--local-status-rejected-color);
    }

    /* IN_PROGRESS */
    .table-locals .status-type.status-4 {
        background: var(--local-status-in-progress-color);
    }

    .table-locals .status-column.status-4 {
        color: var(--local-status-in-progress-color);
    }

    /* COMPLETED */
    .table-locals .status-type.status-5 {
        background: var(--local-status-completed-color);
    }

    .table-locals .status-column.status-5 {
        color: var(--local-status-completed-color);
    }

    /* CANCELED */
    .table-locals .status-type.status-6 {
        background: var(--local-status-canceled-color);
    }

    .table-locals .status-column.status-6 {
        color: var(--local-status-canceled-color);
    }
</style>